import {
    TenderContractsAllComponent,
    TenderContractsAwaitingBidsComponent,
    TenderContractsExpiredComponent
} from '../../../../../../pages';
import {
    TenderBidsResolver,
    TenderContractBidsAnalysisResolver,
    TenderContractsAwaitingBidsResolver, TenderContractsExpiredResolver
} from '../../../../../resolvers';
import { Route } from '@angular/router';

export const contractsExpiredRoute: Route = {
    path: 'expired',
    component: TenderContractsExpiredComponent,
    resolve: {
        contracts: TenderContractsExpiredResolver,
    },
};
